<template>
  <div>
    <vm-table
        ref="vmTable"
        height="59vh"
        :filter.sync="filter"
        module="basic"
        url="system/user"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.editPage.open(0)">新建</el-button>
        <el-button type="danger" @click="deleteIds">批量删除</el-button>
        <el-button type="primary" :loading="exportLoading" @click="exportExcel()">导出</el-button>
        <el-button type="primary" @click="$refs.userLocked.open()">锁定账号解锁</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="用户名">
            <el-input v-model.trim="filter.userName" clearable/>
          </vm-search>
          <vm-search label="用户类型">
            <el-select v-model="filter.userType" clearable>
              <el-option label="内部用户" :value="1"/>
              <el-option label="外部用户" :value="2"/>
              <el-option label="高级用户" :value="3"/>
            </el-select>
          </vm-search>
          <vm-search label="用户信息">
            <el-input v-model.trim="filter.employeeName" clearable/>
          </vm-search>
          <vm-search label="手机">
            <el-input v-model.trim="filter.mobile" clearable/>
          </vm-search>
          <vm-search label="部门">
            <el-input v-model.trim="filter.department" clearable/>
          </vm-search>
          <vm-search label="角色">
            <el-input v-model.trim="filter.roleName" clearable/>
          </vm-search>
          <vm-search label="账套类型">
            <el-select v-model="filter.accountSetName" clearable>
              <el-option
                  v-for="item in accountSetNameList"
                  :key="item.pkid"
                  :label="item.accountSetName"
                  :value="item.accountSetName"/>
            </el-select>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column prop="userName" align="center" width="100" label="用户名"/>
      <el-table-column prop="userTypeName" align="center" width="100" label="用户类型"/>
      <el-table-column prop="employeeName" align="center" label="用户信息"/>
      <el-table-column prop="mobile" align="center" width="120" label="手机"/>
      <el-table-column prop="departmentName" align="center" width="120" label="所属部门"/>
      <el-table-column prop="roleName" align="center" label="所属角色"/>
      <el-table-column
          fixed="right"
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="220">
        <template slot-scope="scope">
          <el-button type="primary" @click="initPassWord(scope.row)">初始化密码</el-button>
          <el-button type="primary" @click="$refs.editPage.open(scope.row.systemUserID)">编辑</el-button>
          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <edit-page ref="editPage" @save-success="getList(-1)"/>
    <user-locked ref="userLocked"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import EditPage from "./UserEdit.vue";
  import UserLocked from "./UserLocked.vue";

  export default {
    name: "UserList",
    components: {VmTable, VmSearch, EditPage,UserLocked},
    data() {
      return {
        exportLoading:false,
        filter: {
          userName: "",
          userType: "",
          employeeName: "",
          mobile: "",
          roleName: "",
          accountSetName: "",
          department:"",
        },
        accountSetNameList:[],
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
      this.getAccountSetNameList();
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      getAccountSetNameList() {
        this.$http
          .get("basic", "accountSets/list")
          .then(resp => {
            console.log(resp);
            this.accountSetNameList = resp;
          });
      },
      onNodeClick(data) {
        this.filter.systemUserID = data.systemUserID;
        this.getList(1);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
      },
      //批量删除
      deleteIds() {
        if(this.idList.length) {
          let ids = [];
          for (let item of this.idList) {
            ids.push(item.systemUserID);
          }
          this.$http
            .delete("basic","system/user",ids).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
              this.idList = "";
            });
        }else{
          this.$message.error("请选择要删除的内容");
        }

      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","system/user",row.systemUserID).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
      initPassWord(row) {
        this.$confirm("确定初始化吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .get("basic",`system/user/${row.systemUserID}/initPassword`).then(() => {
              this.getList(-1);
              this.$message.success("初始化成功!");
            });
        });
      },
      //导出
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic","system/user/export", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>

<style scoped>

</style>
